<template>
	<div style="position: relative">
		<div class="seccion" :style="value.estilos" :class="value.clases" style="border-left: 1px dashed silver;">
			<div>
				<columna v-for="(c, i) in value.columnas" :key="`cpnnte-sccn-${i}${$root.aleatorio}`" v-model="value.columnas[i]"></columna>
			</div>
		</div>

		<v-card elevation="2" style="width: 36px; hheight: 72px; border: 1px solid silver; position: absolute; top: 50%; transform: translateY(-50%); left: -36px">

			<v-tooltip right v-if="cantidadDeSecciones > 0 && posición > 0">
				<template v-slot:activator="{ on, attrs }">
					<v-btn icon v-bind="attrs" v-on="on" @click="subir">
						<v-icon>mdi-arrow-up-bold</v-icon>
					</v-btn>
				</template>
				<span>Mover esta sección hacia arriba</span>
			</v-tooltip>

			<v-tooltip right>
				<template v-slot:activator="{ on, attrs }">
					<v-btn icon v-bind="attrs" v-on="on" @click="editar">
						<v-icon>mdi-cog</v-icon>
					</v-btn>
				</template>
				<span>Configuración</span>
			</v-tooltip>

			<v-tooltip right>
				<template v-slot:activator="{ on, attrs }">
					<v-btn icon v-bind="attrs" v-on="on" @click="eliminar">
						<v-icon>mdi-delete</v-icon>
					</v-btn>
				</template>
				<span>Eliminar esta sección</span>
			</v-tooltip>

			<v-tooltip right v-if="cantidadDeSecciones > 0 && posición+1 < cantidadDeSecciones">
				<template v-slot:activator="{ on, attrs }">
					<v-btn icon v-bind="attrs" v-on="on" @click="bajar">
						<v-icon>mdi-arrow-down-bold</v-icon>
					</v-btn>
				</template>
				<span>Mover esta sección hacia abajo</span>
			</v-tooltip>

		</v-card>

		<v-dialog
			v-model="fondo.seleccionandoImagen"
			max-width="800"
		>
			<seleccionar-medio v-model="fondo.imagen" @hecho="fondo.seleccionandoImagen = false"></seleccionar-medio>
		</v-dialog>

	</div>
</template>

<script>

import Columna from '@/components/constructor/Sitio/Pagina/Seccion/Columna/Columna'
import SeleccionarMedio from '@/components/utilidades/SeleccionarMedio'

export default {
  name: 'Seccion',

  data: () => ({
		editorData: '',

		// Mover seciones de una página a otra ---------------
		// borrar clase imagenes-bordeadas de BD -----------
		// el token está caducando --------------

		fondo: {
			tipo: '',
			color: '#DCDCDCFF',
			imagen: {
				tipo: 'imagen',
				ubicación: ''
			},
			seleccionandoImagen: false,
		},

		texto: {
			color: {
				personalizado: false,
				valor: ''
			},
			espaciado: {
				personalizado: false,
				valor: 2
			}
		},

		espaciado: {
			horizontal: {
				valor: 0,
			},
			vertical: {
				valor: 0,
			},
			intermedio: {
				valor: 0,
			}
		},

		anchura: {
			valor: '',
			opciones: [
				{ 'text': '600 pixeles', 'value': 'anchura-600px' },
				{ 'text': '700 pixeles', 'value': 'anchura-700px' },
				{ 'text': '800 pixeles', 'value': 'anchura-800px' },
				{ 'text': '1000 pixeles', 'value': 'anchura-1000px' },
				{ 'text': '1200 pixeles', 'value': 'anchura-1200px' },
				{ 'text': '1400 pixeles', 'value': 'anchura-1400px' },
				{ 'text': 'Todo el ancho del contenido principal de la página', 'value': '' }
			],
		},

		medios: {
			tipo: '',
			tamaño: 200,
			aspecto: '',
			contenida: false,
		},

	}),

	components: {
		Columna,
		SeleccionarMedio
	},
	
	props: {
		value: {
			type: Object,
			default: function() {
				return { columnas: [] }
			}
		},
		cantidadDeSecciones: {
			type: Number,
			default: 0
		},
		posición: {
			type: Number,
			default: -1
		},
	},

	watch: {
		'fondo.tipo': function() {
			this.aplicarFondo()
		},
		'fondo.color': function() {
			this.aplicarFondo()
		},
		'fondo.imagen.ubicación': function() {
			this.aplicarFondo()
		},
		'texto.color.personalizado': function() {
			this.aplicarTextoColor()
		},
		'texto.color.valor': function() {
			this.aplicarTextoColor()
		},
		'texto.espaciado.personalizado': function() {
			this.aplicarTextoEspaciado()
		},
		'texto.espaciado.valor': function() {
			this.aplicarTextoEspaciado()
		},
		'espaciado.horizontal.valor': function(v) {
			this.eliminarClasesQueEmpiezanPor('espaciado-horizontal-')
			if (v > 0 && v <= 10) {
				this.aplicarClase(`espaciado-horizontal-${v}`)
			}
		},
		'espaciado.vertical.valor': function(v) {
			this.eliminarClasesQueEmpiezanPor('espaciado-vertical-')
			if (v > 0 && v <= 10) {
				this.aplicarClase(`espaciado-vertical-${v}`)
			}
		},
		'espaciado.intermedio.valor': function(v) {
			this.eliminarClasesQueEmpiezanPor('espaciado-intermedio-')
			if (v > 0 && v <= 5) {
				this.aplicarClase(`espaciado-intermedio-${v}`)
			}
		},
		'anchura.valor': function(clase) {
			this.eliminarClasesQueEmpiezanPor('anchura-')
			this.aplicarClase(clase)
		},
		'medios.tipo': function(tipo) {
			for (let c of this.value.columnas) {
				for (let p of c.partes) {
					if (tipo === 'ícono' && p.tipo === 'imagen') {
						this.$set(p, 'tipo', 'ícono')
						if (!p.ícono) {
							this.$set(p, 'ícono', { estilo: '', identificador: '' })
						}
					} else if (tipo === 'imagen' && p.tipo === 'ícono') {
						this.$set(p, 'tipo', 'imagen')
					}
				}
			}
		},
		'medios.tamaño': function() {
			this.mediosTamaño()
		},
		'medios.aspecto': function(aspecto) {
			for (let c of this.value.columnas) {
				for (let p of c.partes) {
					if (p.tipo === 'imagen' || p.tipo === 'ícono') {
						if (aspecto === 'cuadrada') {
							this.$set(p.clases, 'cuadrada', true)
							this.$delete(p.clases, 'redonda')
						} else if (aspecto === 'redonda') {
							this.$set(p.clases, 'redonda', true)
							this.$delete(p.clases, 'cuadrada')
						} else {
							this.$delete(p.clases, 'cuadrada')
							this.$delete(p.clases, 'redonda')
						}
					}
				}
			}
		},
		'medios.contenida': function(contenida) {
			for (let c of this.value.columnas) {
				for (let p of c.partes) {
					if (p.tipo === 'imagen') {
						this.$set(p.clases, 'contenida', contenida)
					}
				}
			}
		},
	},

	mounted() {
		console.log('montado.....') // Esto está ocurriendo al guardar ------------ revisar --------------------
		if (this.value.estilos['background-color']) {
			this.fondo.tipo = 'color'
			this.fondo.color = this.value.estilos['background-color']
		} else if (this.value.estilos['background-image']) {
			this.fondo.tipo = 'imagen'
			this.fondo.imagen.ubicación = this.value.estilos['background-image'].replace(/^url\(/, '').replace(/\)$/, '')
		} else {
			this.fondo.tipo = 'ninguno'
		}

		if (this.value.estilos['color']) {
			this.texto.color.personalizado = true
			this.texto.color.valor = this.value.estilos['color']
		}

		let numEspaciado = function(clase, rplzr) {
			let v = 0
			try {
				v = Number(clase.replace(rplzr, ''))
				v < 0 ? 0 : v > 10 ? 10 : v
			} catch (e) {
				console.error('[75230384]', e)
				window.alert('¡Advertencia! Ocurrió un error inesperado. Por favor comuníquese con el administrador y proporciónele este número de error: 75230384.')
			}

			return v
		}

		for (let clase in this.value.clases) {
			if (clase.indexOf('espaciado-horizontal-') === 0) {
				this.espaciado.horizontal.valor = numEspaciado(clase, 'espaciado-horizontal-')
				break
			}
		}

		for (let clase in this.value.clases) {
			if (clase.indexOf('espaciado-vertical-') === 0) {
				this.espaciado.vertical.valor = numEspaciado(clase, 'espaciado-vertical-')
				break
			}
		}

		for (let clase in this.value.clases) {
			if (clase.indexOf('espaciado-intermedio-') === 0) {
				this.espaciado.intermedio.valor = numEspaciado(clase, 'espaciado-intermedio-')
				break
			}
		}

		if (this.value.clases['anchura-600px']) {
			this.anchura.valor = 'anchura-600px'
		} else if (this.value.clases['anchura-700px']) {
			this.anchura.valor = 'anchura-700px'
		} else if (this.value.clases['anchura-800px']) {
			this.anchura.valor = 'anchura-800px'
		} else if (this.value.clases['anchura-1000px']) {
			this.anchura.valor = 'anchura-1000px'
		} else if (this.value.clases['anchura-1200px']) {
			this.anchura.valor = 'anchura-1200px'
		} else if (this.value.clases['anchura-1400px']) {
			this.anchura.valor = 'anchura-1400px'
		}

		for (let c of this.value.columnas) {
			for (let p of c.partes) {
				if (p.tipo === 'ícono') {
					this.medios.tipo = 'ícono'
				} else if (p.tipo === 'imagen') {
					this.medios.tipo = 'imagen'
					this.medios.contenida = !!p.clases.contenida
				} else if (p.tipo === 'texto') {
					for (let clase in p.clases) {
						if (clase.indexOf('espaciado-') === 0) {
							this.texto.espaciado.personalizado = true
							this.texto.espaciado.valor = numEspaciado(clase, 'espaciado-')
						}
					}
				}
			}
		}

		for (let c of this.value.columnas) {
			for (let p of c.partes) {
				if (p.tipo === 'imagen' || p.tipo === 'ícono') {
					let cls = 0
					for (let clase in p.clases) {
						if (clase.indexOf('tamaño-') === 0) {
							try {
								cls = Number(clase.replace('tamaño-', '').replace('px', ''))
							} catch (e) {
								console.error('[75328042]', e)
								window.alert('¡Advertencia! Ocurrió un error inesperado. Por favor comuníquese con el administrador y proporciónele este número de error: 75328042.')
							}
							break
						}
					}
					this.medios.tamaño = cls < 100 || cls > 600 ? 200 : cls
					this.mediosTamaño()
				}
			}
		}
	},

	methods: {
		eliminar: function() {
			this.$emit('eliminar')
		},
		subir: function() {
			this.$emit('subir')
		},
		bajar: function() {
			this.$emit('bajar')
		},
		editar: function() {
			this.$emit('editar')
		},
		mediosTamaño: function() {
			if (this.medios.tamaño < 100 || this.medios.tamaño > 600) {
				return
			}

			for (let c of this.value.columnas) {
				for (let p of c.partes) {
					if (p.tipo === 'imagen' || p.tipo === 'ícono') {
						for (let clase in p.clases) {
							if (clase.indexOf('tamaño-') === 0) {
								this.$delete(p.clases, clase)
							}
						}
						this.$set(p.clases, `tamaño-${this.medios.tamaño}px`, true)
					}
				}
			}
		},
		aplicarFondo: function() {
			this.fondo.seleccionandoImagen = false

			if (this.fondo.tipo === 'color' && this.fondo.color) {
				this.$set(this.value.estilos, 'background-color', this.fondo.color)
				this.$delete(this.value.estilos, 'background-image')
				this.$delete(this.value.estilos, 'background-position')
				this.$delete(this.value.estilos, 'background-size')
			} else if (this.fondo.tipo === 'imagen' && this.fondo.imagen.ubicación) {
				this.$delete(this.value.estilos, 'background-color')
				this.$set(this.value.estilos, 'background-image', `url(${this.fondo.imagen.ubicación})`)
				this.$set(this.value.estilos, 'background-position', 'center')
				this.$set(this.value.estilos, 'background-size', 'cover')
			} else {
				this.$delete(this.value.estilos, 'background-color')
				this.$delete(this.value.estilos, 'background-image')
				this.$delete(this.value.estilos, 'background-position')
				this.$delete(this.value.estilos, 'background-size')
			}
		},
		aplicarTextoColor: function() {
			if (this.texto.color.personalizado && this.texto.color.valor) {
				this.$set(this.value.estilos, 'color', this.texto.color.valor)
			} else {
				this.$delete(this.value.estilos, 'color')
			}
		},
		aplicarTextoEspaciado: function() {
			for (let c of this.value.columnas) {
				for (let p of c.partes) {
					if (p.tipo === 'texto') {
						for (let clase in p.clases) {
							if (clase.indexOf('espaciado-') === 0) {
								this.$delete(p.clases, clase)
							}
						}
						if (this.texto.espaciado.personalizado && this.texto.espaciado.valor > 0) {
							this.$set(p.clases, `espaciado-${this.texto.espaciado.valor}`, true)
						}
					}
				}
			}
		},
		eliminarClasesQueEmpiezanPor: function(empiezaPor) {
			for (let clase in this.value.clases) {
				if (clase.indexOf(empiezaPor) === 0) {
					this.$delete(this.value.clases, clase)
				}
			}
		},
		aplicarClase: function(clase) {
			this.$set(this.value.clases, clase, true)
		}
	}
};

</script>

<style scoped>
.seccion {
	overflow: unset !important;
}
</style>